import { IRealityCheckData } from "../../../core/src/server/data/IRealityCheckData";
import PointerEvents from "../const/PointerEvents";
import CommManager from "../controllers/CommManager";
import BetModel from "../model/BetModel";
import GameModel from "../model/GameModel";
import RealityCheckModel from "../model/RealityCheckModel";
import RequestRegister from "../server/requests/RequestRegister";
import UIController from "../ui/UIController";
import { UIStates } from "../ui/UIStates";
import { DefaultLayers } from "../utils/Layers";
import Locale, { LocaleId } from "../utils/Locale";
import ViewManager from "../utils/ViewManager";
import { State } from "./State";
import CommandManager from "../commands/CommandManager";
import { Commands } from "../commands/CommandEnum";
import ErrorModel from "../model/ErrorModel";
import ConsoleUtil from "../utils/ConsoleUtil";
import CurrencyUtils from "../utils/CurrencyUtils";
import App from "../App";

export class RealityCheckState extends State {
    constructor(stateMachine) {
        super(stateMachine);
    }

    public enter() {
        ConsoleUtil.log("[Core][RealityCheckState] Enter()");
        super.enter();
        this.initRealityCheck();
    }

    protected initRealityCheck() {
        UIController.setState(UIStates.SPIN);
        CommandManager.execute(Commands.CLOSE_SETTINGS);
        if (GameModel.urlParams.rcshowresult == "true") {
            CommManager.send(RequestRegister.get("sessionResult"), (data) => {
                RealityCheckModel.totalBet = data.betamount;
                RealityCheckModel.totalWin = data.winamount;
                this.showRealityCheck();
            }, true)
        } else {
            this.showRealityCheck();
        }
        // Show dark overlay

    }

    protected showRealityCheck() {
        ViewManager.getLayer("SplashOverlay").setScene("open");


        const elapsedTime = RealityCheckModel.milliSecToMin(
            RealityCheckModel.getElapsedTime()
        );
        const scene = ViewManager.getLayer(DefaultLayers.Popups).setScene(
            "realityCheck"
        );

        // Set title label
        scene.sceneTextFields.get("title").text = Locale.getString(
            LocaleId.rc_title_session_length
        );

        // Set message body
        let messageBody = Locale.getString(LocaleId.rc_session_tie);

        scene.sceneTextFields.get("text").text = messageBody;

        // Set continue button
        const exitButton = scene.buttons.get("continue");
        exitButton.setValue(Locale.getString(LocaleId.but_cp));
        exitButton.on(PointerEvents.DOWN, () => {
            ViewManager.getLayer(DefaultLayers.Popups).clear();

            // Clear limit
            CommManager.send(
                RequestRegister.get("resetRealityCheck"),
                (data) => {
                    ConsoleUtil.log("[AuthState] Reset RC response", data);
                    // Also reset the model
                    RealityCheckModel.update(<IRealityCheckData>{
                        sessionMinutes: 0
                    });

                    // Hide the overlay
                    ViewManager.getLayer("SplashOverlay").clear();

                    // Then exit the state
                    this.exit();
                },
                this,
                (err) => {
                    this.handleError(err);
                }
            );
        });

        // Set lobby button
        const lobbyButton = scene.buttons.get("lobby");
        lobbyButton.setValue(Locale.getString(LocaleId.but_rl));
        lobbyButton.on(PointerEvents.DOWN, () => {
            ViewManager.getLayer(DefaultLayers.Popups).clear();
            CommandManager.execute(Commands.GO_HOME);

            // Then exit the state
            this.exit();
        });

        // Set account history button
        const historyButton = scene.buttons.get("history");
        historyButton.setValue(Locale.getString(LocaleId.but_ah));

        if (GameModel.urlParams.rchistoryurl) {
            // ONLY up event works on iOS!!!
            historyButton.on(PointerEvents.UP, () => {
                CommandManager.execute(Commands.OPEN_RC_HISTORY);
            });
        } else {
            historyButton.setVisible(false);
        }
    }

    handleError(err) {
        ErrorModel.update(err);
        this.exit();
    }
}
